import request from "@/utils/request";
import { ElMessage } from "element-plus";

export default {
    name: "BuildingInfo",
    components: {},
    data() {
        return {
            loading: true,
            disabled: false,
            judge: false,
            dialogVisible: false,
            search: "",
            currentPage: 1,
            pageSize: 10,
            total: 0,
            tableData: [],
            form: {
                dormBuildId: "",
                dormBuildName: "",
                dormBuildDetail: "",
            },
            rules: {
                dormBuildId: [
                    { required: true, message: "请输入编号", trigger: "blur" },
                    {
                        pattern: /^(1|[1-9]\d?|100)$/,
                        message: "范围：1-100",
                        trigger: "blur",
                    },
                ],
                dormBuildName: [
                    { required: true, message: "请输入名称", trigger: "blur" },
                ],
                dormBuildDetail: [
                    { required: true, message: "请输入备注", trigger: "blur" },
                ],
            },
            baseUrl: "",
             dialogTableVisible: false,
             errorRecords: [],
        };
    },
    created() {
        this.load();
        this.loading = true;
        setTimeout(() => {
            //设置延迟执行
            this.loading = false;
        }, 1000);
        this.baseUrl = process.env.VUE_APP_BASE_TARGET || window.location.origin;
    },
    methods: {
        handleAvatarSuccess(res, file) {
            this.$refs.upload.clearFiles();
            console.log(res);
            const successCount = res.successCount || 0;
            const failCount = res.failCount || 0;
            const skipCount = res.skipCount || 0;
            const totalCount = res.totalCount || (successCount + failCount + skipCount);
            const errorData = res.data || [];
            if (errorData.length > 0) {
                this.dialogTableVisible = true;
                this.errorRecords = errorData;
                this.load();
                const skipMsg = skipCount > 0 ? `，跳过(重复) ${skipCount} 条` : '';
                ElMessage({
                    message: `导入完成：成功 ${successCount} 条，失败 ${failCount} 条${skipMsg}，共 ${totalCount} 条`,
                    type: "warning",
                });
                return;
            }
            const skipMsg = skipCount > 0 ? `，跳过(重复) ${skipCount} 条` : '';
            const type = skipCount > 0 ? "warning" : "success";
            ElMessage({
                message: `导入成功 ${successCount} 条${skipMsg}，共 ${totalCount} 条`,
                type: type,
            });
            this.load();
        },
        handleError(err, file) {
            this.$refs.upload.clearFiles();
            ElMessage({
                message: "导入失败",
                type: "error",
            });
        },
        downloadTemplate() {
            // 下载导入模板
            if (process.env.NODE_ENV === 'development') {
                const backendUrl = process.env.VUE_APP_BASE_TARGET;
                window.location.href = backendUrl + "/学员入住信息导入模板.xlsx";
            } else {
                window.location.href = window.location.origin + "/学员入住信息导入模板.xlsx";
            }
        },
        exportData() {
            // 获取当前浏览器地址，开发环境下用环境变量VUE_APP_BASE_TARGET，生产环境下用当前地址
            if (process.env.NODE_ENV === 'development') {
                const backendUrl = process.env.VUE_APP_BASE_TARGET;
                window.location.href = backendUrl + "/execl/export";
                console.log(backendUrl + "/execl/export");
            } else {
                window.location.href = window.location.origin + "/api/execl/export";
            }
        },
        async load() {
            request.get("/building/find", {
                params: {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                    search: this.search,
                },
            }).then((res) => {
                console.log(res);
                this.tableData = res.data.records;
                this.total = res.data.total;
                this.loading = false;
            });
        },
        reset() {
            this.search = ''
            request.get("/building/find", {
                params: {
                    pageNum: 1,
                    pageSize: this.pageSize,
                    search: this.search,
                },
            }).then((res) => {
                console.log(res);
                this.tableData = res.data.records;
                this.total = res.data.total;
                this.loading = false;
            });
        },
        filterTag(value, row) {
            return row.dormBuildDetail === value;
        },
        add() {
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.form.resetFields();
                this.disabled = false;
                this.form = {};
                this.judge = false;
            });
        },
        save() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.judge === false) {
                        //新增
                        request.post("/building/add", this.form).then((res) => {
                            console.log(res);
                            if (res.code === "0") {
                                ElMessage({
                                    message: "新增成功",
                                    type: "success",
                                });
                                this.search = "";
                                this.load();
                                this.dialogVisible = false;
                            } else {
                                ElMessage({
                                    message: res.msg,
                                    type: "error",
                                });
                            }
                        });
                    } else {
                        //修改
                        request.put("/building/update", this.form).then((res) => {
                            console.log(res);
                            if (res.code === "0") {
                                ElMessage({
                                    message: "修改成功",
                                    type: "success",
                                });
                                this.search = "";
                                this.load();
                                this.dialogVisible = false;
                            } else {
                                ElMessage({
                                    message: res.msg,
                                    type: "error",
                                });
                            }
                        });
                    }
                }
            });
        },
        cancel() {
            this.$refs.form.resetFields();
            this.dialogVisible = false;
        },
        handleEdit(row) {
            //修改
            this.judge = true;
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.form.resetFields();
                // 生拷贝
                this.form = JSON.parse(JSON.stringify(row));
                this.disabled = true;
            });
        },
        handleDelete(id) {
            console.log(id);
            request.delete("/building/delete/" + id).then((res) => {
                if (res.code === "0") {
                    ElMessage({
                        message: "删除成功",
                        type: "success",
                    });
                    this.search = "";
                    this.load();
                } else {
                    ElMessage({
                        message: res.msg,
                        type: "error",
                    });
                }
            });
        },
        handleSizeChange(pageSize) {
            //改变每页个数
            this.pageSize = pageSize;
            this.load();
        },
        handleCurrentChange(pageNum) {
            //改变页码
            this.currentPage = pageNum;
            this.load();
        },
    },
};